import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import * as Exp from '../../../experimentConstants'
import Button from '@doordash/component-button'
import ChangeLanguage from '../change-language'
import ChangeLanguageForNewSignup from '../change-language-new-signup'
import t from './strings'
import {
  HeaderActionsWrapper,
  LanguageSelectWrapper,
  SignUpWrapper,
  HeaderLoginButtonWrapper,
  HeaderOptionsWrapper,
} from './styles'
import { Text } from '@doordash/design-language'
import { DASHER_SIGN_UP_SUPPORT_URL } from '../../../constants'
import { getDesktopNavItem, DesktopNavItems } from '../../atoms/hamburger-menu'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import i18n from '../../../i18n'

const { logIn, signUp, support } = t

type ReduxProps = {
  toggleAlreadyStartedSigningUpModal?: () => void
  trackLandingPageHeader?: (data: DA.LandingPageHeader) => void
}

const handleClick = (
  history,
  trackLandingPageHeader: (data: DA.LandingPageHeader) => void,
  anchor: string,
  trackingId: DA.HeaderNames
) => {
  trackLandingPageHeader({
    action: DA.EventActions.Clicked,
    name: trackingId,
  })
  history.push(`${history.location.search}${anchor}`)
}

type ItemType = {
  text: string
  anchor: string
  trackingId: DA.HeaderNames
  fn?: () => void
}

type HeaderProps = {
  showGetStarted: boolean
}

/**
 * Returns the Support link based on the language selected
 */
const getSupportLink = () => {
  const currentLanguage = i18n.getCurrentLocale().replace('-', '_')
  return `${DASHER_SIGN_UP_SUPPORT_URL}?language=${currentLanguage}`
}

const textProps = {
  size: Text.Sizes.S14,
  weight: Text.Weights.Bold,
}

export const DesktopHeaderActions: React.FC<RouteComponentProps &
  ReduxProps &
  HeaderProps> = ({
  history,
  trackLandingPageHeader,
  toggleAlreadyStartedSigningUpModal,
  showGetStarted,
}) => {
  const links: ItemType[] = [
    getDesktopNavItem(DesktopNavItems.learnMore),
    getDesktopNavItem(DesktopNavItems.faq),
  ]

  const items = links.map((item: ItemType) => {
    return (
      <Button
        type={Button.Types.Plain}
        key={item.text}
        size={Button.Sizes.Small}
        onClick={() =>
          handleClick(
            history,
            trackLandingPageHeader,
            item.anchor,
            item.trackingId
          )
        }
      >
        <Text {...textProps}>{item.text}</Text>
      </Button>
    )
  })

  return (
    <HeaderActionsWrapper>
      <LanguageSelectWrapper>
        {isFeatureFlagEnabled(Exp.DX_WOLT_JP_TRANSITION) ? (
          <ChangeLanguageForNewSignup />
        ) : (
          <ChangeLanguage />
        )}
      </LanguageSelectWrapper>
      <HeaderOptionsWrapper>
        {items}
        <Button
          type={Button.Types.Plain}
          tag="a"
          href={getSupportLink()}
          target="_blank"
          size={Button.Sizes.Small}
          onClick={() => {
            trackLandingPageHeader({
              action: DA.EventActions.Clicked,
              name: DA.HeaderNames.MenuOptionSupport,
            })
          }}
        >
          <Text {...textProps}>{support()}</Text>
        </Button>
        <HeaderLoginButtonWrapper>
          <Button
            type={Button.Types.PrimaryPill}
            inline={true}
            onClick={() => {
              toggleAlreadyStartedSigningUpModal()
              trackLandingPageHeader({
                action: DA.EventActions.Clicked,
                name: DA.HeaderNames.LogInButton,
              })
            }}
          >
            <Text {...textProps} color={Text.Colors.BackgroundElevated}>
              {logIn()}
            </Text>
          </Button>
          <SignUpWrapper showGetStarted={showGetStarted}>
            <Button
              type={Button.Types.TertiaryPill}
              inline={true}
              onClick={() =>
                handleClick(
                  history,
                  trackLandingPageHeader,
                  getDesktopNavItem(DesktopNavItems.signUpForm).anchor,
                  DA.HeaderNames.MenuOptionSignUp
                )
              }
            >
              <Text {...textProps}>{signUp()}</Text>
            </Button>
          </SignUpWrapper>
        </HeaderLoginButtonWrapper>
      </HeaderOptionsWrapper>
    </HeaderActionsWrapper>
  )
}

const mapDispatchToProps = {
  trackLandingPageHeader: events.trackLandingPageHeader,
}

export default connect(
  null,
  mapDispatchToProps
)(withRouter(DesktopHeaderActions))
